import React, { useEffect, useRef, useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import "./PassengerStepper.css";

/**
 * Selector de cantidad con botones +/- animados, en vez del <input type="number">
 * nativo (poco cómodo de usar y con controles inconsistentes entre navegadores).
 */
const PassengerStepper = ({
  name,
  value,
  onChange,
  min = 1,
  max = 999,
  label = "Número de pasajeros",
}) => {
  const numericValue = Number.isFinite(Number(value)) ? Number(value) : min;
  const [isBumping, setIsBumping] = useState(false);
  const prevValueRef = useRef(numericValue);

  useEffect(() => {
    if (prevValueRef.current !== numericValue) {
      prevValueRef.current = numericValue;
      setIsBumping(true);
      const timer = setTimeout(() => setIsBumping(false), 220);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [numericValue]);

  const clamp = (next) => Math.min(max, Math.max(min, next));
  const commit = (next) => onChange(name, clamp(next));

  const handleInputChange = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      onChange(name, "");
      return;
    }
    const parsed = parseInt(raw, 10);
    if (!Number.isNaN(parsed)) {
      onChange(name, parsed);
    }
  };

  const handleBlur = () => commit(numericValue);

  return (
    <div className="stepper">
      <button
        type="button"
        className="stepper-btn stepper-btn-minus"
        onClick={() => commit(numericValue - 1)}
        disabled={numericValue <= min}
        aria-label={`Disminuir ${label.toLowerCase()}`}
      >
        <FiMinus aria-hidden="true" />
      </button>
      <input
        type="number"
        inputMode="numeric"
        className={`stepper-input${isBumping ? " is-bumping" : ""}`}
        name={name}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        min={min}
        max={max}
        role="spinbutton"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={numericValue}
        aria-label={label}
      />
      <button
        type="button"
        className="stepper-btn stepper-btn-plus"
        onClick={() => commit(numericValue + 1)}
        disabled={numericValue >= max}
        aria-label={`Aumentar ${label.toLowerCase()}`}
      >
        <FiPlus aria-hidden="true" />
      </button>
    </div>
  );
};

export default PassengerStepper;
